import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Layers, Leaf, Zap, Smartphone, Monitor, Tablet } from 'lucide-react';
export function TrustBand() {
  const items = [{
    icon: BookOpen,
    text: 'Más de 360 recetas'
  }, {
    icon: Layers,
    text: '9 Kits especializados'
  }, {
    icon: Leaf,
    text: 'Ingredientes reales'
  }, {
    icon: Zap,
    text: 'Acceso inmediato'
  }, {
    icon: Smartphone,
    text: 'Compatible con celular'
  }, {
    icon: Monitor,
    text: 'Compatible con PC'
  }, {
    icon: Tablet,
    text: 'Compatible con Tablet'
  }];
  return <div className="bg-white border-y border-ink/5 py-6 overflow-hidden" data-id="element-973">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-974">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4" data-id="element-975">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className="flex items-center gap-2 text-ink-light" data-id="element-976">
              <item.icon className="w-5 h-5 text-combo-green" data-id="element-977" />
              <span className="text-sm font-medium whitespace-nowrap" data-id="element-978">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}